import React from "react";
import { Slide, ToastContainer } from "react-toastify";

export const NotificationWrapper = () => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={700}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      // pauseOnFocusLoss={false}
      // pauseOnHover={false}
      draggable
      pauseOnHover
      theme="dark"
      transition={Slide}
    />
  );
};
